<template>
    <b-card class="mb-0">
        <div slot="header" class="text-uppercase">
            {{ $t('seo_configuration.seo') }}
        </div>

        <b-collapse visible id="seo_configration_content">
            <b-row>
                <b-col cols="12">
                    <b-form-group v-bind:label="$t('seo_configuration.url')" :label-cols="2" :horizontal="true">
                        <b-form-input type="text" v-bind:placeholder="$t('seo_configuration.url')"
                            class="form-control border-radius-4px" v-model="seoUrl" readonly></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group v-bind:label="$t('seo_configuration.snippet_preview')" :label-cols="2" :horizontal="true">
                        <div class="snippet-preview">
                            <h3 class="snippet-preview-product-title">
                                {{ countProductTitle <= PRODUCT_TILE_LIMIT ? item.meta_title : item.meta_title.substring(0,
                                    PRODUCT_TILE_LIMIT) + '...' }}</h3>
                                    <div class="long-meta-description snippet-preview-meta-description"
                                        v-html="countMetaDescription <= META_DESCRIPTION_LIMIT ? (item.meta_description || '').replace(/\n/g, '<br />') : item.meta_description.substring(0, META_DESCRIPTION_LIMIT).replace(/\n/g, '<br />') + '...'">
                                    </div>
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <div class="form-group row">
                        <legend class="col-sm-2 col-form-label">{{$t('seo_configuration.product_title')}} <span
                        class='text-danger'>*</span></legend>
                        <div class="col-sm-10">
                            <b-form-input
                                ref="titleMeta"
                                class="form-control border-radius-4px"
                                :class="isRequireTitle && 'is-invalid'"
                                v-model="item.meta_title"
                                maxlength="60"
                                @input="updateProductTitle"
                            />
                            <b-form-invalid-feedback :id="'meta_title'">
                                {{ $t('message.required_filed') }}
                            </b-form-invalid-feedback>
                            <div
                                :class="countProductTitle <= PRODUCT_TILE_LIMIT ? 'metadata-description' : 'metadata-description invalid'">
                                {{ $t('seo_configuration.count_character', {
                                    count: countProductTitle, limit: PRODUCT_TILE_LIMIT
                                }) }}
                            </div>
                        </div>
                  </div>
                </b-col>
                <b-col cols="12">
                    <div class="form-group row">
                        <legend class="col-sm-2 col-form-label">{{$t('seo_configuration.meta_description')}} <span
                        class='text-danger'>*</span></legend>
                        <div class="col-sm-10">
                            <textarea rows="5" v-bind:placeholder="$t('seo_configuration.meta_description')"
                                ref="descriptionMeta"
                                class="form-control border-radius-4px" v-model="item.meta_description"
                                :class="isRequireDescription && 'is-invalid'"
                                maxlength="160"
                                @input="updateMetaDescription">
                            </textarea>
                            <b-form-invalid-feedback :id="'meta_title'">
                                {{ $t('message.required_filed') }}
                            </b-form-invalid-feedback>
                            <div
                                :class="countMetaDescription <= META_DESCRIPTION_LIMIT ? 'metadata-description' : 'metadata-description invalid'">
                                {{ $t('seo_configuration.count_character', {
                                    count: countMetaDescription, limit:
                                        META_DESCRIPTION_LIMIT
                                }) }}
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12">
                    <b-form-group v-bind:label="$t('seo_configuration.primary_keyword')" :label-cols="2" :horizontal="true">
                        <multiselect v-model="seoPrimaryKeywordOptions"
                            v-bind:tag-placeholder="$t('seo_configuration.press_enter_to_add')"
                            v-bind:placeholder="$t('seo_configuration.primary_keyword')" label="name" track-by="code"
                            :options="seoPrimaryKeywordOptions" :multiple="true" :taggable="true" @tag="addPrimaryKeyword">
                        </multiselect>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group v-bind:label="$t('seo_configuration.h1_headings')" :label-cols="2" :horizontal="true">
                        <b-form-input type="text" v-bind:placeholder="$t('seo_configuration.h1_headings')"
                            class="form-control border-radius-4px" v-model="item.h1_headings"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-collapse>
    </b-card>
</template>
  
<style scoped></style>
  
<script>
import Multiselect from 'vue-multiselect'
let vm = null

export default {
    name: 'SeoConfiguration',
    components: {
        Multiselect
    },
    props: {
        seoUrl: {
            type: String,
            default: ''
        },
        itemSingle: {
            type: Object,
            default: () => {}
        },
        customize: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            item: {
                meta_title: '',
                meta_description: ''
            },
            countMetaDescription: 0,
            countProductTitle: 0,
            seoPrimaryKeywordOptions: [],
            PRODUCT_TILE_LIMIT: 60,
            META_DESCRIPTION_LIMIT: 160,
            config: this.$session.get('config'),
            isRequireTitle: false,
            isRequireDescription: false
        }
    },
    methods: {
        checkRequire() {
            if(!this.item.meta_title || !this.item.meta_description) {
                this.isRequireTitle = !this.item.meta_title ? true : false
                this.isRequireDescription = !this.item.meta_description ? true : false
                if (!this.item.meta_title) {
                    this.$refs.titleMeta.focus()
                } else if (!this.item.meta_description) {
                    this.$refs.descriptionMeta.focus()
                }
                return false
            }
            return true
        },
        updateMetaDescription(e) {
            vm.countMetaDescription = vm._.get(vm.item, 'meta_description', '').length
        },
        updateProductTitle(e) {
            vm.countProductTitle = vm._.get(vm.item, 'meta_title', '').length
        },
        addPrimaryKeyword(newTag) {
            const tag = {
                code: newTag.replaceAll(' ', '-'),
                name: newTag
            }
            vm.seoPrimaryKeywordOptions.push(tag)
        },
        getSeoConfigurationParams() {
            vm.item.primary_keyword = vm.seoPrimaryKeywordOptions.map(i => i.name)
            let params = {
                product_title: vm.item.meta_title,
                meta_description: vm.item.meta_description,
                primary_keyword: vm.item.primary_keyword,
                h1_headings: vm.item.h1_headings
            }
            return params
        },
        createAndUpdateSEO() {
            let vm = this
            vm.item.primary_keyword = vm.seoPrimaryKeywordOptions.map(i => i.name)
            let params = {
                uuid: vm.item.seo_campaign_uuid || vm.itemSingle.uuid,
                client: vm.config.base.id || '',
                category_id: 0,
                menu_id: 0,
                campaign_id: 0,
                store_id: 0,
                url: vm.seoUrl || (vm.item.seo_campaign_url || ''),
                customize_fields: vm.item.seo_campaign_customize_fields || {},
                snippet_preview: vm.item.seo_campaign_snippet_preview || '',
                meta_title: vm.item.meta_title || '',
                meta_description: vm.item.meta_description || '',
                h1_headings: vm.item.h1_headings || '',
                primary_keyword: vm.item.primary_keyword || ''
            }
            params.category_id = vm.itemSingle.slug ? vm.itemSingle.id : 0 // with category it is itemSingle.id
            params.menu_id = vm.itemSingle.slug ? 0 : vm.itemSingle.id // with menu it is itemSingle.id
            // params.campaign_id = // SEO for campaign
            // params.store_id = // SEO for hut
            let errorTitle = vm.$t('message.error')
            let messageError = vm.$t('message.update_seo_failed')
            if(vm.item.seo_campaign_uuid) {
              vm.axios.menu.updateSEOinfo(params, function (response) {
              }, function (error) {
                messageError = error.errors ? (Array.isArray(error.errors) ? error.errors[0] : error.errors) : messageError
                vm.$toastr.error(messageError, errorTitle, {})
              })
            } else {
              vm.axios.menu.createSEOinfo(params, function (response) {
              }, function (error) {
                messageError = error.errors ? (Array.isArray(error.errors) ? error.errors[0] : error.errors) : messageError
                vm.$toastr.error(messageError, errorTitle, {})
              })
            }
        },
        getSeoDetail(uuid, customize, dataItem) {
            let param = {
              client: vm.config.base.id,
              uuid: uuid
            }
            vm.item.seo_campaign_uuid = null
            let seoConfig = (customize && customize.seo_configuration) || null
            let meta_title = (seoConfig && seoConfig.product_title) || (dataItem && dataItem.name && dataItem.name.en) || vm.itemSingle.name_seo
            let seo_meta_description = (seoConfig && seoConfig.meta_description) || (dataItem && dataItem.main_description && dataItem.main_description.en) || 'Default'
            let seo_primary_keyword = (seoConfig && seoConfig.primary_keyword) || []
            let seo_h1_headings = (seoConfig && seoConfig.h1_headings) || vm.itemSingle.name_seo
            vm.axios.menu.getSEOCampaign(param, function (response) {
              let seoData = response.data.data
              if (seoData) {
                vm.item.seo_campaign_uuid = seoData.uuid
                vm.item.seo_campaign_campaign_id = seoData.campaign_id
                vm.item.seo_campaign_store_id = seoData.store_id
                vm.item.seo_campaign_url = seoData.url
                vm.item.seo_campaign_customize_fields = seoData.customize_fields
                vm.item.seo_campaign_snippet_preview = seoData.snippet_preview
                meta_title = seoData.meta_title || meta_title
                seo_meta_description = seoData.meta_description || seo_meta_description
                seo_primary_keyword = (seoData.primary_keyword && seoData.primary_keyword.length === 0) ? seo_primary_keyword : seoData.primary_keyword
                seo_h1_headings = seoData.h1_headings || seo_h1_headings
              }
              vm.item.meta_title = meta_title
              vm.item.meta_description = seo_meta_description
              vm.item.primary_keyword = seo_primary_keyword
              if (typeof vm.item.primary_keyword === "object") {
                  vm.seoPrimaryKeywordOptions = vm.item.primary_keyword === null ? [] : Object.values(vm.item.primary_keyword).map(i => ({ code: i.replaceAll(' ', '-'), name: i }))  
              } else if (Array.isArray(vm.item.primary_keyword)) {
                  vm.item.primary_keyword.map(i => ({ code: i.replaceAll(' ', '-'), name: i }))
              } else {
                  vm.seoPrimaryKeywordOptions = [{ code: vm.item.primary_keyword.replaceAll(' ', '-'), name: vm.item.primary_keyword }]
              }
              vm.item.h1_headings = seo_h1_headings
              vm.countMetaDescription = vm.item.meta_description.length
              vm.countProductTitle = vm.item.meta_title.length
            }, function () {
                vm.$toastr.error(vm.$t('message.error'), vm.$t('message.update_seo_failed'), {})
            })
        }
    },
    created() {
        vm = this
        this.$root.$on('createOrUpdateSEOConfiguration', vm.createAndUpdateSEO)
        this.$root.$on('getSeoDetail', (uuid, customize, item) => {
            vm.getSeoDetail(uuid, customize, item)
        })
    },
    beforeDestroy() {
        this.$root.$off('createOrUpdateSEOConfiguration')
        this.$root.$off('getSeoDetail')
    },
    watch: {
        'item.meta_title': function(newVal, oldVal) {
            if(newVal && newVal.length > 0) {
                this.isRequireTitle = false
            } else this.isRequireTitle = true
        },
        'item.meta_description': function(newVal, oldVal) {
            if(newVal && newVal.length > 0) {
                this.isRequireDescription = false
            } else this.isRequireDescription = true
        }
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.metadata-description {
    margin-top: 0.25rem;
    font-size: 80%;
}

.invalid {
    color: #f86c6b;
}

.snippet-preview {
    border: 1px solid #e4e5e6;
    padding: 10px;
    height: 100px;
    overflow-y: auto;
}

.long-meta-description {
    max-width: 600px
}

.snippet-preview-product-title {
    display: inline-block;
    line-height: 1.3;
    margin-bottom: 3px;
    font-family: arial, sans-serif;
    font-size: 20px;
    font-weight: 400;
    margin: 0;
    padding: 0;
    color: #1a0dab;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, .1);
}

.snippet-preview-meta-description {
    color: #3c4043;
    padding-top: 0;
    margin-bottom: 0;
    text-align: left;
    font-family: arial, sans-serif;
    font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/Partials/SeoConfiguration.vue